import { render, staticRenderFns } from "./ParticaWebsites.vue?vue&type=template&id=584111bb&"
import script from "./ParticaWebsites.vue?vue&type=script&lang=ts&"
export * from "./ParticaWebsites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports